/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/Stages/A2/components/A2EnergySummary.tsx.
 */

import React from "react";

interface Props {
  /** Cumulative embodied energy from all fuel rows (MJ). */
  energyMj: number;
  /** Total ÷ background finished material declared qty, when qty is known. */
  energyPerDeclaredFinishedMj?: number | null;
  /** Unit for per-finished qty (from Background finished material unit). */
  perFinishedUnitLabel?: string;
}

const A2EnergySummary: React.FC<Props> = ({
  energyMj,
  energyPerDeclaredFinishedMj,
  perFinishedUnitLabel = "MJ per finished qty",
}) => {
  return (
    <div className="embodied-carbon-summary-container a2-derived-summary">
      <div className="ecs-row">
        <div className="ecs-col ecs-col-left">
          <label className="ecs-label">
            Cumulative embodied energy (all fuels, A2)
          </label>
          <input readOnly value={String(energyMj)} className="ecs-input" />
        </div>
        <div className="ecs-col ecs-col-right">
          <label className="ecs-label">Unit</label>
          <input readOnly value="MJ" className="ecs-input" />
        </div>
      </div>
      {energyPerDeclaredFinishedMj != null &&
      Number.isFinite(energyPerDeclaredFinishedMj) ? (
        <div className="ecs-row ecs-row-secondary">
          <div className="ecs-col ecs-col-left">
            <label className="ecs-label">
              Embodied energy per functional unit
            </label>
            <input
              readOnly
              value={String(energyPerDeclaredFinishedMj)}
              className="ecs-input"
            />
          </div>
          <div className="ecs-col ecs-col-right">
            <label className="ecs-label">Unit</label>
            <input readOnly value={perFinishedUnitLabel} className="ecs-input" />
          </div>
        </div>
      ) : null}
    </div>
  );
};

/** React component — A2Energy Summary. */
export default A2EnergySummary;
